var _path, _circle, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--native-icon-fill)"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.63 1.113a.662.662 0 0 1 .74 0L14 4.903v9.424c0 .178-.07.35-.195.476a.663.663 0 0 1-.472.197H2.667a.663.663 0 0 1-.472-.197.676.676 0 0 1-.195-.476V4.903l5.63-3.79Zm-4.297 12.54h9.334v-8.03L8 2.483l-4.667 3.14v8.03Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 6,
    r: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9h4v1H6zM6 11h4v1H6z"
  })));
};

export default SvgTag;